@use '@design/design-tokens/border-radius/border-radius' as *;
@use '@design/design-tokens/typography/typography' as *;

.menuButtonContainer {
  display: none;
  align-items: center;
  justify-content: center;
  gap: 4px;
  margin: 0 8px;
}

.priceContainer {
  display: flex;
  align-items: center;
  margin-left: 16px;
}

.legendItemDetails {
  display: flex;
  align-items: center;
  @include border-radius-r1;
}

.legendItemRoot {
  padding: 2px;
  display: flex;
  align-items: center;
  background-color: var(--background-soft);
  margin-bottom: 8px;
  @include border-radius-r1;
  border: 1px solid var(--border-soft);

  &.isHighlighted {
    border: 1px solid var(--border-hover);

    .menuButtonContainer {
      display: flex;
    }

    .priceContainer {
      display: none;
    }
  }

  &.hasHover {
    &:has(.legendItemDetails:hover) {
      border: 1px solid var(--border-hover);

      .menuButtonContainer {
        display: flex;
      }

      .priceContainer {
        display: none;
      }
    }
  }
}

.assetContainer {
  display: flex;
  align-items: center;
}

.label {
  text-transform: uppercase;
}

.button {
  padding: 0;
  background: none;
  border: 0;
  color: inherit;
  @include typography-v2-body-base;
  cursor: pointer;

  &.isUpperCase {
    text-transform: uppercase;
  }
}

.legendButtonWrapper {
  border-radius: 2px;
  padding: 0 4px;
  display: flex;
  gap: 4px;
  align-items: center;
  cursor: default;

  &:hover {
    background-color: var(--surface-hover);
  }
}

.asset {
  display: flex;
  align-items: center;
  @include typography-v2-body-base;
}

.separatorDot {
  margin: 0 4px;
  fill: var(--icon-default);
}

.menuIconSpan {
  cursor: pointer;
  height: 20px;
  width: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;

  &:hover {
    background-color: var(--surface-hover);
  }
}

.entityNameWrapper {
  color: var(--text-soft);
  @include typography-v2-body-sm;
}
